export class novedadAsesor {
      nombre?: string
      fecha?: string;
      ciudad?: string;
      email?: string;
      telefono?: string;
      observacion?: string;
      identificacion?: string;
      numCOntrato?: string;
      nombreUsuario?: string;
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/novedadAsesor.ts